import styles from "./MapStatusView.module.scss";
import { Spinner } from 'seagull';
import React from 'react';
export function MapStatusView(props) {
  const {
    mapStatus
  } = props;
  let element;
  switch (mapStatus) {
    case 'mapped':
      element = /*#__PURE__*/React.createElement("div", {
        className: styles.mapped
      }, "Mapped");
      break;
    case 'notMapped':
      element = /*#__PURE__*/React.createElement("div", {
        className: styles.notMapped
      }, "Not mapped");
      break;
    case 'failedToMap':
      element = /*#__PURE__*/React.createElement("div", {
        className: styles.failedToMap
      }, "Failed to map");
      break;
    case 'mapping':
      element = /*#__PURE__*/React.createElement(Spinner, {
        "data-testid": "map-spinner",
        size: 32
      });
      break;
    default:
      element = null;
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "map-status"
  }, element);
}